import { springfieldMaConfig } from "./data";
import CityPageTemplate from "@/pages/city-template/CityPageTemplate";

export default function SpringfieldMaPage() {
  return <CityPageTemplate config={springfieldMaConfig} />;
}